
import { Box } from "@mui/material";
import { ILocation } from "../../../interfaces/common/location";
import AddressWithIcon from "../styles/address-with-icon";

export const DisplayLocations = ({locations}: {locations: ILocation[]; }) => {
    return <Box>
            {locations.slice(0,1).map(l => <AddressWithIcon key={l.id} address={l} />)}
        </Box>
}